import { Routes } from '@angular/router';
import { inject } from '@angular/core';
// TODO: set up better import paths.
import { QuotePageComponent } from './quote-page/quote-page.component';
// Home page removed; base path now redirects to quotes
import { QuotesListPageComponent } from './quotes-list-page/quotes-list-page.component';
import { TeamPageComponent } from './team-page/team-page.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { AuthGuard } from './guards/auth.guard';
import { Error404PageComponent } from './error-404-page/error-404-page.component';
import { ForbiddenPageComponent } from './forbidden-page/forbidden-page.component';
import { AccessDeniedPageComponent } from './access-denied-page/access-denied-page.component';
import { PricingPageComponent } from './pricing-page/pricing-page.component';
import { MaterialsPageComponent } from './materials-page/materials-page.component';
import { EquipmentPageComponent } from './equipment-page/equipment-page.component';
import { ConsumablesPageComponent } from './consumables-page/consumables-page.component';
import { tradeStudyToolsGuard } from './trade-study-tools.guard';
import { BlueprintsPageComponent } from './blueprints-page/blueprints-page.component';
import { CustomersPageComponent } from './customers-page/customers-page.component';
import { StoragePageComponent } from './storage-page/storage-page.component';
import { MouldingPageComponent } from './moulding-page/moulding-page.component';
import { MouldingListPageComponent } from './moulding-list-page/moulding-list-page.component';
import { SettingsService } from './settings-page/settings-service/settings.service';
import { BillingPageComponent } from './billing-page/billing-page.component';
import { tokenBillingGuard } from './token-billing.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'quotes',
    pathMatch: 'full',
  },
  {
    path: 'quotes',
    component: QuotesListPageComponent,
    title: 'Quotes',
    canActivate: [AuthGuard],
  },
  {
    path: 'quote/:quoteId/:revisionNumber',
    component: QuotePageComponent,
    title: 'Quote',
    canActivate: [AuthGuard],
  },
  {
    path: 'blueprints',
    component: BlueprintsPageComponent,
    title: 'Blueprints',
    canActivate: [AuthGuard],
  },
  {
    path: 'team',
    component: TeamPageComponent,
    title: 'Team',
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    redirectTo: 'settings/organisation',
    pathMatch: 'full',
  },
  {
    path: 'settings/:tab',
    loadComponent: () =>
      import('./settings-page/settings-page.component').then(
        (m) => m.SettingsPageComponent,
      ),
    title: 'Settings',
    canActivate: [AuthGuard],
  },
  {
    path: 'billing',
    component: BillingPageComponent,
    title: 'Billing',
    canActivate: [AuthGuard],
    canMatch: [tokenBillingGuard],
  },
  {
    path: 'materials',
    component: MaterialsPageComponent,
    title: 'Materials',
    canActivate: [AuthGuard],
  },
  {
    path: 'equipment',
    component: EquipmentPageComponent,
    title: 'Equipment',
    canActivate: [AuthGuard],
    canMatch: [tradeStudyToolsGuard],
  },
  {
    path: 'consumables',
    component: ConsumablesPageComponent,
    title: 'Consumables',
    canActivate: [AuthGuard],
    canMatch: [() => inject(SettingsService).isConsumablesEnabled$()],
  },
  {
    path: 'pricing-models',
    component: PricingPageComponent,
    title: 'Pricing Models',
    canActivate: [AuthGuard],
  },
  {
    path: 'customers',
    component: CustomersPageComponent,
    title: 'Customers',
    canActivate: [AuthGuard],
  },
  {
    path: 'storage',
    component: StoragePageComponent,
    title: 'Storage',
    canActivate: [AuthGuard],
  },
  {
    path: 'auto-molds',
    component: MouldingListPageComponent,
    title: 'Auto Molds',
    canActivate: [AuthGuard],
    canMatch: [() => inject(SettingsService).isMouldingEnabled$()],
  },
  {
    path: 'auto-molds/:id',
    component: MouldingPageComponent,
    title: 'Auto Mold',
    canActivate: [AuthGuard],
    canMatch: [() => inject(SettingsService).isMouldingEnabled$()],
  },
  {
    path: 'verify-email',
    component: VerifyEmailComponent,
    title: 'Verify Email',
  },
  {
    // No AuthGuard: the signed-in account has no access to this tenant.
    path: 'access-denied',
    component: AccessDeniedPageComponent,
    title: 'Access Denied',
  },
  {
    path: 'forbidden',
    component: ForbiddenPageComponent,
    title: 'Access Forbidden',
  },
  { path: '**', component: Error404PageComponent, canActivate: [AuthGuard] }, // Wildcard route for a 404 page
];
